import {
  ITEMPATH,
  ITEMADDED,
  ITEMDIALOGSTATUS,
  ITEMLOADING,
} from "@/store/actions/item";

const state = {
  from: null,
  redirected: null,
  item: null,
  active: null,
  loading: null,
};

const getters = {
  getItemState: (state) => state,
  getItemPath: (state) => state.from,
  getAddedItem: (state) => state.item,
  getItemDialogStatus: (state) => state.active,
  getItemLoadingStatus: (state) => state.loading,
};

const actions = {};

const mutations = {
  [ITEMPATH]: (state, value) => {
    state.from = value;
  },
  [ITEMADDED]: (state, value) => {
    state.item = value;
  },
  [ITEMDIALOGSTATUS]: (state, value) => {
    state.active = value;
  },
  [ITEMLOADING]: (state, value) => {
    state.loading = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
